const initAuth = (app) => {
  if (typeof window === "undefined") {
    return void 0;
  }
  return app.__internals__.auth();
};

const getServices = (app) => {
  if (typeof window === "undefined") {
    return void 0;
  }
  return app.__instance__.auth;
};

export { getServices, initAuth };
//# sourceMappingURL=bundle.esm.js.map
